﻿(function () {
    'use strict';
    angular.module('winxnet', [])
        .service('stateService', function () {
            var grids = {};

            var stateSvc = {
                registerGrid: function (gridName, data) {
                    grids[gridName] = data;
                },
                registerScope: function (scopeName, data) {
                    grids[scopeName] = data;
                },
                scope: function (scopeName) {
                    if (grids.hasOwnProperty(scopeName)) {
                        return grids[scopeName];
                    }
                    return null;
                },
                grid: function (gridName) {
                    if (grids.hasOwnProperty(gridName)) {
                        return grids[gridName];
                    }
                    return null;
                },
                grids: function () { return grids; }
            };
            return stateSvc;
        })

        // View Data Service
        .service('viewDataService', [
            '$rootElement', function ($rootElement) {

                var viewDataElement = $rootElement.find('#AngularViewData');
                var viewData = null;
                if (viewDataElement.length > 0) {
                    viewData = angular.fromJson(viewDataElement.html());
                }

                return {
                    data: viewData
                };
            }
        ])

        // List Data Source
        .directive('listDataSource', [
            '$parse', '$compile', function ($parse, $compile) {
                return {
                    priority: 1000,
                    restrict: 'E',
                    scope: false,
                    link: function (scope, element, attrs) {
                        if (!scope.model) {
                            scope.model = {};
                        }
                        scope.model[attrs.datasourcename] = $parse(element.text())();
                    }
                };
            }
        ])

        // Excellent Checkbox List
        .directive('winxnetCheckboxList', [
            '$filter', function ($filter) {
                var listNum = 0;
                return {
                    //transclude:true,
                    priority: 50,
                    restrict: 'EA',
                    scope: {
                        readOnly: '=',
                        itemList: '=',
                        selectedItemList: '=',
                        checkboxListChange: "&"
                    },
                    link: function (scope, element, attrs, controller) {
                        scope.class = attrs.cssclass;
                        scope.valueProperty = attrs.valueProperty;
                        scope.checkboxdata = [];

                        scope.selectItem = function (value) {
                            if (value.canBeNew) {
                                value.isNew = value.selected;
                            } else if (value.canDelete) {
                                value.isDeleted = !value.selected;
                            }
                            if (scope.checkboxListChange && scope.checkboxdata) {
                                scope.checkboxListChange({ data: scope.checkboxdata, item: value });
                            }
                        }

                        var newKey = -1;
                        var i;
                        for (i = 0; i < scope.itemList.length; i++) {

                            var item = scope.itemList[i];
                            var name = 'cb_' + listNum + '_' + i;

                            var elementData = {
                                text: item.Text,
                                index: i,
                                name: name,
                                collection: attrs.collectionName,
                                value: item.Value,

                            };
                            var selectedItem = null;
                            for (var val in scope.selectedItemList) {
                                if (scope.selectedItemList[val][scope.valueProperty] == item.Value) {
                                    selectedItem = scope.selectedItemList[val];
                                    break;
                                }
                            }
                            if (selectedItem && (selectedItem.Id > 0 || selectedItem.IsNew)) {//Bug 4724: Add New Sales Rep Error
                                elementData.canBeNew = selectedItem.IsNew;
                                elementData.canDelete = true;
                                elementData.isNew = selectedItem.IsNew;
                                elementData.isDeleted = selectedItem.IsDeleted;
                                elementData.selected = !selectedItem.IsDeleted;
                                elementData.id = selectedItem.Key;
                            } else {
                                elementData.isNew = false;
                                elementData.isDeleted = false;
                                elementData.selected = false;
                                elementData.canBeNew = true;
                                elementData.canDelete = false;
                                elementData.id = newKey--;
                            }
                            scope.checkboxdata.push(elementData);
                        }
                        if (scope.checkboxListChange) {
                            scope.checkboxListChange({ data: scope.checkboxdata });
                        }
                        listNum++;
                    },
                    //template: '<div>nnn</div>'
                    template: '<div class="checkbox-list {{class}}">' +
                        '<div ng-repeat="item in checkboxdata"><div ng-show="!readOnly || item.selected">' +
                        '<input ng-hide="readOnly" ng-click="selectItem(item)" type="checkbox" name="{{item.name}}" id="{{item.name}}" ng-checked="{{item.selected}}" ng-model="item.selected"/>' +
                        '<label for="{{item.name}}">{{item.text}}</label>' +
                        '<input type="hidden" id="{{item.collection}}[{{item.index}}].Key" name="{{item.collection}}[{{item.index}}].Key" value="{{item.id}}" />' +
                        '<input type="hidden" id="{{item.collection}}[{{item.index}}].Value.{{valueProperty}}" name="{{item.collection}}[{{item.index}}].Value.{{valueProperty}}" value="{{item.value}}" />' +
                        '<input type="hidden" id="{{item.collection}}[{{item.index}}].Value.Id" name="{{item.collection}}[{{item.index}}].Value.Id" value="{{item.id}}" />' +
                        '<input type="hidden" id="{{item.collection}}[{{item.index}}].Value.IsNew" name="{{item.collection}}[{{item.index}}].Value.IsNew" value="{{item.isNew}}" ng-model="item.isNew" />' +
                        '<input type="hidden" id="{{item.collection}}[{{item.index}}].Value.IsDeleted" name="{{item.collection}}[{{item.index}}].Value.IsDeleted" value="{{item.isDeleted}}" ng-model="item.isDeleted" />' +
                        '</div>' +
                        '</div></div>'
                }
            }
        ])




        .directive('saveGridContext', ['utilityService', function (utilityService) {
            return {
                priority: 1000,
                restrict: 'A',
                replace: false,
                scope: {},

                link: function (scope, element, attrs) {

                    var submitFunction = function (event) {

                        var result = false;

                        if (utilityService.utility.alternateSaveFunction) {
                            event.preventDefault();
                            var alternateResult = utilityService.utility.alternateSaveFunction();
                            if (alternateResult) {
                                result = true;
                            }
                        } else {
                            // Plain old submit
                            result = true;
                        }

                        return result;
                    };

                    // TODO
                    // I AM 100% sure there is a better way of doing this. However,
                    // I need to move on and for now this is working.
                    element.bind('submit', function (event) {

                        var result = submitFunction(event);

                        if (result) {
                            var items = utilityService.utility.createModifiedItemsFormElementCollection();
                            element.append(items);
                            element.unbind('submit');
                            element.submit();
                        }

                    });
                }

            };
        }
        ])


        ;
})();
